// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import { Main } from "../generalStyle";
import DeletedPatientFromOrion from "../../components/deletedPatientFromOrion";

const DeletedPatientFromOrionView = () => (
  <>
    {VerifyToken()}
    <Main>
      <DeletedPatientFromOrion />
    </Main>
  </>
);

export default DeletedPatientFromOrionView;
